<template>
  <div class="login-spacing">
    <h1>Bestätigungscode eingeben</h1>
    <h4>Der Code wurde an die Telefonnr. mit der Endung {{tempPhoneNumber}} geschickt.</h4>
    <div class="login-form-wrapper">

      <b-alert v-model="hasError" variant="danger" v-if="hasError">
        {{ errorMessage }}
      </b-alert>

      <b-alert v-model="isSucceded" v-else-if="isSucceded" variant="success">
        Der Code wurde erneut zugestellt.
      </b-alert>

      <b-alert v-model="hasUnknownError" variant="danger" v-else>
        {{ unknownErrorMessage }}
      </b-alert>

      <validation-observer ref="observer" v-slot="{ passes }">
        <b-form @submit.prevent="passes(onSubmit)" @reset.prevent="reset">

          <validation-provider vid="code" rules="required" name="code" v-slot="{ valid, errors, changed }">
            <b-form-group id="input-group-code" label="Bestätigungscode" label-for="input-code">
              <b-form-input
                id="input-code"
                ref="authCode"
                v-model="form.code"
                :state="onValidateField(valid, errors, changed)"
                placeholder="Bestätigungscode eingeben"
              ></b-form-input>
              <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <b-form-group>
            <b-form-checkbox
              id="check-loggon"
              v-model="form.rememberDevice"
              name="checkbox-stay-logged-in"
            >
              Diesem Gerät für 30 Tage vertrauen
            </b-form-checkbox>
          </b-form-group>
          <b-button type="submit" variant="primary" class="w-100" disabled v-if="isSubmitting">
            <b-spinner small></b-spinner>
            Prüfen
          </b-button>
          <b-button type="submit" variant="primary" class="w-100" v-else>Prüfen</b-button>
        </b-form>
      </validation-observer>
    </div>
    <h1>Kein Bestätigungscode erhalten?</h1>
    <ul class="code-list">
      <li>
        <a @click="resendCode" href="#">Bestätigungscode erneut senden</a>
      </li>
      <li>
        <router-link to="/telefonnummer-aendern">Telefonnr. für Bestätigungscode ändern?</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { errorHandler, validateField } from '@/helpers/formHelper.js'

  const getInitialData = () => ({
    form: {
      code: '',
      rememberDevice: true
    }
  })

  export default {
    components: {
      ValidationObserver,
      ValidationProvider
    },
    data: () => ({
      isSubmitting: false,
      isSucceded: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      hasError: false,
      errorMessage: '',
      ...getInitialData()
    }),
    mounted () {
      this.$refs.authCode.focus()
    },
    methods: {
      async onSubmit () {
        this.isSubmitting = true
        this.hasUnknownError = false
        this.hasError = false
        this.errorMessage = ''

        this.$store.dispatch('user/VALIDATE_AUTH_CODE', this.form).then(res => {
          const { errors } = res

          if (errors) {
            const error = errors[0].extensions

            if (error.code === 'CODE_INVALID') {
              this.hasError = true
              this.errorMessage = this.$t(`formError.${error.i18n}`)
              this.isSubmitting = false
              return
            }

            if (error.code === 'LOGIN_SESSION_EXPIRED') {
              this.$router.push({ name: 'login' }).catch((e) => {})
            }

            this.isSubmitting = false
            return errorHandler(this, errors)
          }

          this.$router.push({ path: 'uebersicht' }).catch(() => {})
          this.isSubmitting = false
        }).catch(err => {
          this.isSubmitting = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      resendCode () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('user/RESEND_AUTH_CODE').then(res => {
          const { data, errors } = res

          if (errors) {
            const error = errors[0].extensions

            if (error.code === 'SMS_BLOCKED') {
              this.hasError = true
              this.errorMessage = this.$t(`formError.${error.i18n}`)
              this.isSubmitting = false
              return
            }

            return errorHandler(this, errors)
          }

          const { ok } = data.userSend2FACode
          if (ok) {
            this.isSucceded = true
          }
        }).catch(err => {
          this.isSubmitting = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      },
      reset () {
        Object.assign(this.$data, getInitialData())
        requestAnimationFrame(() => {
          this.$refs.observer.reset()
        })
      }
    },
    computed: {
      ...mapState({
        tempPhoneNumber: state => state.user.tempPhoneNumber
      })
    }
  }
</script>

<style lang="scss" scoped>
  .login-spacing{
    margin-top: 7rem;
    margin-bottom: 7rem;
  }
  .login-form-wrapper{
    max-width: 320px;
    margin: 0 auto;
  }

  .code-list{
    list-style: none;
    margin: 0;
    padding: 0;
    line-height: 2;
  }

  .Cookie{
    background-color: $gray;
  }

  .Cookie__content{
    font-size: 0.75rem !important;

    a{
      color: $green;

      &:hover{
        color: $green;
      }
    }
  }
</style>
